import React, { Component } from 'react';
import { Route } from 'react-router';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { keyUserToken } from '../../store/constants';
import { hasAllowedRoles } from '../helper/rolesHelper';
import { loggedInUserSelector } from '../selectors/authSelectors';
import {IsLoggedIn} from '../../helper/HelperAuth'

class ProtectedRoute extends Component {
    render() {
        const {
            component: Component,
            allowedRoles,
            ...props } = this.props;

        let isAllowed = IsLoggedIn;
        return (
            <Route
                {...props}  
                render={(props) => {
                    return (
                        isAllowed ?
                            <Component {...props} /> :
                            window.location = 'login'
                    );      
                }}
            />
        )
    }
}

export default connect(
    (state) => {
        return {
            loggedInUser: loggedInUserSelector(state),
        }
    },
    null,
)(ProtectedRoute);